import apiClient from 'api/apiClient';

export const getConfiguration = ({ productKey }) => apiClient.get(`/v1/products/${productKey}/configurations`);

export const getConfigurationChanges = ({ productKey }) => apiClient.get(`/v1/products/${productKey}/configurations/changes`);
